<form [formGroup]="form">
  <ng-content></ng-content>
  <div class="row">
    <div class="col-12 text-center">
      <s1-button class="mr-1" [type]="s1ButtonType.Reset" (onClick)="reset()"></s1-button>
      <s1-button class="mr-1" [type]="s1ButtonType.Search" (onClick)="search()"></s1-button>
    </div>
  </div>
</form>